export default class FormDataSourceGroupResult
{
    remoteClass = "gongqi.erp.gotmodel.form.datasource.FormDataSourceGroupResult";
    groupAlias;
    aliasList;
    dataResult;
    recordCounts;
    maxCounts = -1;	//-1表示未知
    commandResult;
    autoSaveRecord = true;
    
}


// WEBPACK FOOTER //
// ./src/forms/sys/datasource/FormDataSourceGroupResult.js